
if (!customElements.get("bs-popup-actions")) {
class BSPopupActions extends HTMLElement {
    constructor() {
      super();
  
      this.btns = this.querySelectorAll(".js-action-btn");
      this.actionsBlock = this.querySelector('.js-header-actions')
      this.toggleDropdown = this.querySelector('.js-header-btn')
      this.closes = this.querySelectorAll(".js-popup-actions-close");
      this.popupActionsByType = this.querySelector(".js-popup-actions");
    }

    connectedCallback() {
      if (this.btns && this.popupActionsByType) {
        this.close();
        this.toggleActionsBlock();
        this.handleAction();
      }
    }

    toggleActionsBlock() {
      if (!this.actionsBlock || !this.toggleDropdown) return

      this.toggleDropdown.addEventListener('click', ()=> {
        this.actionsBlock.classList.toggle('is-open');
      })

      window.addEventListener('click', (event) => {
          if (!this.actionsBlock.contains(event.target)) {
            this.actionsBlock.classList.remove('is-open');
          }
      })
    }

    handleAction() {
        this.btns.forEach(btn => {
            btn.addEventListener("click", () => {
                const typeAction = btn.dataset.action;
                const isPopupOpen = this.popupActionsByType.classList.contains('is-open')
                if (!isPopupOpen) {
                  this.openPopupByType(typeAction);
                }
            })
        });

        this.closes?.forEach(close => {
          close.addEventListener("click", () => {
            this.close();
          })
      });
    }

    openPopupByType(type) {
        if (!type) return
        this.popupActionsByType.classList.add('is-open', `is-open-${type}`);
        this.popupActionsByType.setAttribute('data-action-show' , type);
        this.actionsBlock.classList.remove('is-open');
    }

    close() {
        this.popupActionsByType.classList.remove('is-open')
    }
  }
  
  customElements.define("bs-popup-actions", BSPopupActions);
}